<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
  <li id="{{ 'tab-parameters' }}" [ngbNavItem]="'parameters'" [domId]="'parameters'">
    <button ngbNavLink routerLink="." [queryParams]="{ tab: 'parameters' }">{{ 'Parameters' | translate }}</button>
    <ng-template ngbNavContent>
      <app-organization [organizationCode]="auth.currentOrganization.code"/>
    </ng-template>
  </li>
  <li id="{{ 'tab-users' }}" [ngbNavItem]="'users'" *ngIf="userFeatures.has(ACL_ORGANIZATION_USERS_MANAGE)">
    <button ngbNavLink routerLink="." [queryParams]="{ tab: 'users' }">{{ 'utilisateurs' | translate }}</button>
    <ng-template ngbNavContent>
      <app-organization-users />
    </ng-template>
  </li>
  <li id="{{ 'tab-sentShares' }}" [ngbNavItem]="'sentShares'" *ngIf="userFeatures.has(ACL_SITE_SHARE)">
    <button ngbNavLink routerLink="." [queryParams]="{ tab: 'sentShares' }">{{ 'SentShares' | translate }}</button>
    <ng-template ngbNavContent>
      <app-sent-shares />
    </ng-template>
  </li>

  <li
    id="{{ 'tab-receivedShares' }}"
    [ngbNavItem]="'receivedShares'"
    *ngIf="userFeatures.has(ACL_ORGANIZATION_MANAGE)"
  >
    <button ngbNavLink routerLink="." [queryParams]="{ tab: 'receivedShares' }">
      {{ 'ReceivedShares' | translate }}
    </button>
    <ng-template ngbNavContent>
      <app-received-shares />
    </ng-template>
  </li>
  @if (userFeatures.has(ACL_CUSTOM_PAGES_PROFILE_MANAGE)) {
  <li *featureFlag="'customPagesProfile'" [ngbNavItem]="'errorHandling'" id="{{ 'tab-errorHandling' }}">
    <button [queryParams]="{ tab: 'errorHandling' }" ngbNavLink routerLink=".">
      <i class="icofont icofont-barricade mr-1"></i> {{ 'ErrorHandler.title' | translate }}
    </button>
    <ng-template ngbNavContent>
      <app-custom-pages-profiles></app-custom-pages-profiles>
    </ng-template>
  </li>
  }
  <li id="{{ 'tab-export' }}" [ngbNavItem]="'export'" *ngIf="userFeatures.has(ACL_PUSH_LOG_MANAGE)">
    <button ngbNavLink routerLink="." [queryParams]="{ tab: 'export' }">
      {{ 'LogExport' | translate }}
    </button>
    <ng-template ngbNavContent>
      <app-push-log />
    </ng-template>
  </li>
  <li id="{{ 'tab-tlsOptions' }}" [ngbNavItem]="'tlsOptions'" *ngIf="userFeatures.has(ACL_TLS_OPTIONS_MANAGE)">
    <button ngbNavLink routerLink="." [queryParams]="{ tab: 'tlsOptions' }">
      {{ 'TlsOptions.label' | translate }}
      <label-beta />
    </button>
    <ng-template ngbNavContent>
      <app-tls-options />
    </ng-template>
  </li>
  <li *ngIf="hasContract$ | async" id="{{ 'tab-myContracts' }}" [ngbNavItem]="'myContracts'">
    <button ngbNavLink routerLink="." [queryParams]="{ tab: 'myContracts' }">
      {{ 'myContracts.title' | translate }}
      <label-beta />
    </button>
    <ng-template ngbNavContent>
      <app-my-contracts />
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
